import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';

import { VacancyRoutingModule } from './vacancy-routing.module';
import { VacancyComponent } from './vacancy.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';


@NgModule({
  declarations: [
    VacancyComponent,
    BreadcrumbComponent,
    DashboardComponent
  ],
  imports: [
    SharedModule,
    VacancyRoutingModule
  ]
})
export class VacancyModule { }
